import moment from 'moment';

import type {
  IRelationshipManagerAssignment,
  IRelationshipManagerContactProvider,
} from '../../../../../utils/types';

// The endpoint returns the guardian's whole assignment history, so the card shows the most
// recently started assignment that is in effect today — one that has already begun and has not
// ended. Without the date_start check a future assignment would sort first and be shown early.
export function getCurrentRelationshipManager(
  assignments: Array<IRelationshipManagerAssignment>,
): IRelationshipManagerContactProvider | null {
  const today = moment();
  const currentAssignment = assignments
    .filter(
      ({ date_start, date_end }) =>
        moment(date_start).isSameOrBefore(today, 'day') &&
        (!date_end || moment(date_end).isSameOrAfter(today, 'day')),
    )
    .sort((a, b) => moment(b.date_start).diff(moment(a.date_start)))[0];

  return currentAssignment?.relationship_manager_provider ?? null;
}
